import { Controller } from 'react-hook-form';
import { ICommonFormProps } from '@src/components/DynamicForm';
import { FormLabel, MultiSelect, SingleSelect } from '@src/components/ui';
import { useSelectPlan } from './hooks';

export const FormSelectPlan = (props: Readonly<ICommonFormProps>) => {
    const {
        label,
        keyName,
        control,
        className,
        registerOptions,
        formProps,
        inputProperties,
        disabled,
    } = props;

    const {
        options,
        hasMore,
        isLoading,
        isFetching,
        fetchPlans,
        loadMore,
        resetSearch,
    } = useSelectPlan(formProps?.countryId, disabled);

    return (
        <div className={className}>
            <Controller
                control={control}
                name={keyName}
                render={({ field, fieldState: { error } }) => {
                    const handleChange = (val: any) => {
                        if (formProps?.isMulti) {
                            field.onChange(val ?? []);
                        } else {
                            field.onChange(val ?? null);
                        }
                    };
                    return (
                        <>
                            {label && (
                                <FormLabel
                                    label={label}
                                    required={
                                        typeof registerOptions?.required ===
                                        'object'
                                            ? Boolean(
                                                  registerOptions.required.value
                                              )
                                            : Boolean(registerOptions?.required)
                                    }
                                />
                            )}

                            {formProps?.isMulti ? (
                                <MultiSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select plans'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchPlans}
                                    onClear={() => resetSearch()}
                                    disabled={disabled}
                                />
                            ) : (
                                <SingleSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select a plan'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchPlans}
                                    onClear={() => resetSearch()}
                                    disabled={disabled}
                                />
                            )}

                            {error?.message && (
                                <div className="text-red-500 text-sm mt-0">
                                    {error.message}
                                </div>
                            )}
                        </>
                    );
                }}
            />
        </div>
    );
};
